module.exports = __webpack_public_path__ + "img/help_content4.7c43c4b2.png";